var map = {
	"./cambridge-university-press-logo.png": "d1b4",
	"./de-gruyter-logo.png": "6e83",
	"./oxford-university-press-logo.png": "d4c7",
	"./royal-society-publishing-logo.png": "d628",
	"./the-mit-press-logo.png": "bac0",
	"./the-university-of-chicago-press-logo.png": "1f07",
	"./university-of-calgary-press-logo.png": "3312",
	"./university-of-chicago-press-journals-logo.png": "7bdb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b53a";